{
  "engagement.title": "Company",
  "engagement.subtitle": "News, policies, surveys and celebrations at 404 Creative.",
  "engagement.tabs.label": "Company sections",
  "engagement.tabs.news": "News",
  "engagement.tabs.policies": "Policies",
  "engagement.tabs.surveys": "Surveys",
  "engagement.tabs.celebrations": "Celebrations",
  "engagement.language.readEnglish": "Read in English",
  "engagement.language.readArabic": "اقرأ بالعربي",
  "engagement.language.back": "Back to English",
  "engagement.news.pinned": "Pinned",
  "engagement.news.unread": "New",
  "engagement.news.yourDepartment": "For your department",
  "engagement.news.readMore": "Read more",
  "engagement.news.showLess": "Show less",
  "engagement.news.until": "Until {date}",
  "engagement.news.loadError": "We couldn’t load the announcements.",
  "engagement.news.emptyTitle": "No news yet",
  "engagement.news.emptyBody": "When HR publishes an announcement, you’ll find it here.",
  "engagement.policies.loadError": "We couldn’t load the policies.",
  "engagement.policies.emptyTitle": "No policies published yet",
  "engagement.policies.emptyBody": "Company policies will appear here once HR publishes them.",
  "engagement.policies.waiting": "{count, plural, one {One policy is waiting for you} other {# policies are waiting for you}}",
  "engagement.policies.waitingBody": "Open each one, read it, and confirm with “I have read and understood”.",
  "engagement.policies.revisionOn": "Revision {number} · {date}",
  "engagement.policies.forReading": "For reading",
  "engagement.policies.toAcknowledge": "To acknowledge",
  "engagement.policies.acknowledgedShort": "Acknowledged {date}",
  "engagement.policies.acknowledgedOn": "You acknowledged this revision on {date}.",
  "engagement.policies.revisionNote": "When a policy changes, HR publishes a new revision and everyone is asked to read and acknowledge it again.",
  "engagement.policies.acknowledge": "I have read and understood",
  "engagement.policies.acknowledging": "Saving…",
  "engagement.policies.later": "Later",
  "engagement.policies.acknowledgeHint": "Confirming records that you read this revision. If the policy changes, you’ll be asked again.",
  "engagement.policies.acknowledgedToast": "Thanks, your acknowledgement is recorded.",
  "engagement.surveys.loadError": "We couldn’t load the surveys.",
  "engagement.surveys.emptyTitle": "No open surveys",
  "engagement.surveys.emptyBody": "When HR opens a survey, you can answer it here.",
  "engagement.surveys.anonymous": "Anonymous",
  "engagement.surveys.named": "Not anonymous",
  "engagement.surveys.questions": "{count, plural, one {# question} other {# questions}}",
  "engagement.surveys.closesOn": "Closes {date}",
  "engagement.surveys.answered": "Thank you, you answered",
  "engagement.surveys.answer": "Answer",
  "engagement.answer.backToSurveys": "All surveys",
  "engagement.answer.loadError": "We couldn’t load this survey.",
  "engagement.answer.closedTitle": "This survey is closed",
  "engagement.answer.closedBody": "It no longer takes answers. Thank you for your interest.",
  "engagement.answer.anonymousTitle": "This survey is anonymous",
  "engagement.answer.anonymousBody": "Nobody, not even HR, can see who gave which answer. We only record that you took part, so you aren’t asked twice. Results show only once at least 3 people have answered.",
  "engagement.answer.namedTitle": "This survey is not anonymous",
  "engagement.answer.namedBody": "Your name is kept with your answers, and HR can see who answered what.",
  "engagement.answer.formLabel": "Your answers",
  "engagement.answer.questionNumber": "Question {number}",
  "engagement.answer.optional": "Optional",
  "engagement.answer.required": "Please answer this question.",
  "engagement.answer.scaleLow": "Strongly disagree",
  "engagement.answer.scaleHigh": "Strongly agree",
  "engagement.answer.npsLow": "Not at all likely",
  "engagement.answer.npsHigh": "Extremely likely",
  "engagement.answer.textHintAnonymous": "Please don’t write anything that could identify you, such as your name or a specific incident.",
  "engagement.answer.textHint": "Your answer is shared with HR with your name.",
  "engagement.answer.missing": "{count, plural, one {One required question is still unanswered.} other {# required questions are still unanswered.}}",
  "engagement.answer.send": "Send my answers",
  "engagement.answer.sending": "Sending…",
  "engagement.answer.once": "You can answer once; answers can’t be changed after sending.",
  "engagement.answer.thanksTitle": "Thank you for answering",
  "engagement.answer.thanksBody": "Your answers are in. They help us make 404 Creative a better place to work.",
  "engagement.answer.answeredTitle": "Thank you, you answered",
  "engagement.answer.answeredBody": "You’ve already answered this survey. Each person answers once.",
  "engagement.celebrations.upcoming": "Coming up",
  "engagement.celebrations.upcomingDescription": "Birthdays and work anniversaries in the next {days} days.",
  "engagement.celebrations.loadError": "We couldn’t load the celebrations.",
  "engagement.celebrations.emptyTitle": "Nothing to celebrate yet",
  "engagement.celebrations.emptyBody": "Birthdays and work anniversaries show here when they come up.",
  "engagement.celebrations.today": "Today",
  "engagement.celebrations.tomorrow": "Tomorrow",
  "engagement.celebrations.birthday": "Birthday",
  "engagement.celebrations.anniversary": "{years, plural, one {# year at 404 Creative} other {# years at 404 Creative}}",
  "engagement.celebrations.preferenceTitle": "What I share",
  "engagement.celebrations.preferenceDescription": "Choose what the team sees about you here and on Home.",
  "engagement.celebrations.preferenceError": "We couldn’t load your choice.",
  "engagement.celebrations.shareBirthday": "Share my birthday",
  "engagement.celebrations.shareBirthdayHint": "Only the day and month show, never your age.",
  "engagement.celebrations.shareAnniversary": "Share my work anniversary",
  "engagement.celebrations.shareAnniversaryHint": "The team sees how many years you’ve been with us.",
  "engagement.celebrations.preferenceSaved": "Saved.",
  "engagement.errors.announcementNotFound": "That announcement is no longer available.",
  "engagement.errors.policyNotFound": "That policy is no longer available.",
  "engagement.errors.surveyNotFound": "That survey isn’t open any more.",
  "engagement.errors.surveyState": "That step doesn’t apply to the survey right now. Refresh and try again.",
  "engagement.errors.alreadyAnswered": "You’ve already answered this survey. Thank you!",
  "engagement.hub.title": "Engagement",
  "engagement.hub.nav": "Engagement sections",
  "engagement.hub.announcements": "Announcements",
  "engagement.hub.policies": "Policies",
  "engagement.hub.surveys": "Surveys",
  "engagement.hub.noAccessTitle": "Engagement is managed by HR managers",
  "engagement.hub.noAccessBody": "Publishing announcements and policies and running surveys needs the “Manage HR” permission. Ask an owner if you need it.",
  "engagement.form.titleAr": "Title in Arabic",
  "engagement.form.titleEn": "Title in English",
  "engagement.form.bodyAr": "Text in Arabic",
  "engagement.form.bodyEn": "Text in English",
  "engagement.form.errors.titleAr": "Write the title in Arabic.",
  "engagement.form.errors.titleEn": "Write the title in English.",
  "engagement.form.errors.bodyAr": "Write the text in Arabic.",
  "engagement.form.errors.bodyEn": "Write the text in English.",
  "engagement.form.audience": "Audience",
  "engagement.form.everyone": "Everyone",
  "engagement.form.expiresOn": "Show until",
  "engagement.form.expiresHint": "Leave empty to keep it up until you unpublish it.",
  "engagement.form.pinned": "Pin to the top",
  "engagement.form.pinnedHint": "Pinned announcements stay above the rest.",
  "engagement.form.requiresAck": "Ask everyone to acknowledge it",
  "engagement.form.requiresAckHint": "People confirm “I have read and understood”, and you can see who hasn’t yet.",
  "engagement.form.saveDraft": "Save draft",
  "engagement.form.save": "Save",
  "engagement.form.saving": "Saving…",
  "engagement.manage.announcementsIntro": "Write announcements in Arabic and English, choose who they reach and publish them when ready.",
  "engagement.manage.announcementsCaption": "Announcements, drafts included",
  "engagement.manage.newAnnouncement": "New announcement",
  "engagement.manage.editAnnouncement": "Edit announcement",
  "engagement.manage.announcementHint": "Saved as a draft. People see it only once you publish it.",
  "engagement.manage.announcementSaved": "Announcement saved.",
  "engagement.manage.noAnnouncementsTitle": "No announcements yet",
  "engagement.manage.noAnnouncementsBody": "Write the first one to share news with the team.",
  "engagement.manage.columnTitle": "Title",
  "engagement.manage.columnStatus": "Status",
  "engagement.manage.columnPublished": "Published",
  "engagement.manage.columnReads": "Read by",
  "engagement.manage.columnAcknowledged": "Acknowledged",
  "engagement.manage.columnActions": "Actions",
  "engagement.manage.draft": "Draft",
  "engagement.manage.published": "Published",
  "engagement.manage.expired": "Expired",
  "engagement.manage.oneDepartment": "One department",
  "engagement.manage.editNamed": "Edit “{title}”",
  "engagement.manage.publish": "Publish",
  "engagement.manage.unpublish": "Unpublish",
  "engagement.manage.publishTitle": "Publish “{title}”?",
  "engagement.manage.publishBodyEveryone": "It reaches everyone now, marked as new until they read it.",
  "engagement.manage.publishBodyDepartment": "It reaches the chosen department now, marked as new until they read it.",
  "engagement.manage.unpublishTitle": "Unpublish “{title}”?",
  "engagement.manage.unpublishBody": "It goes back to a draft and disappears from everyone’s news. Who read it is kept.",
  "engagement.manage.publishedToast": "Announcement published.",
  "engagement.manage.unpublishedToast": "Announcement back to draft.",
  "engagement.manage.policiesIntro": "Keep the company’s policies in one place. Each published revision asks everyone to acknowledge it again.",
  "engagement.manage.policiesCaption": "Company policies, drafts included",
  "engagement.manage.newPolicy": "New policy",
  "engagement.manage.editPolicy": "Edit policy",
  "engagement.manage.noPoliciesTitle": "No policies yet",
  "engagement.manage.noPoliciesBody": "Add the first policy, such as working hours or remote work.",
  "engagement.manage.revision": "Revision {number}",
  "engagement.manage.publishRevision": "Publish new revision",
  "engagement.manage.publishPolicyTitle": "Publish revision {number}?",
  "engagement.manage.publishPolicyBody": "Everyone will be asked to read and acknowledge this policy again, including people who acknowledged an earlier revision.",
  "engagement.manage.publishPolicyBodyNoAck": "Everyone will see the new text. This policy doesn’t ask for an acknowledgement.",
  "engagement.manage.policyPublishedToast": "Revision {number} published.",
  "engagement.manage.policySaved": "Policy saved as a draft.",
  "engagement.manage.policySavedPublished": "Saved. Publish a new revision to share the change.",
  "engagement.manage.policyEditNote": "People keep seeing the published revision until you publish this change as a new revision.",
  "engagement.manage.trackingTitle": "Acknowledgements",
  "engagement.manage.trackingNamed": "Who acknowledged “{title}”",
  "engagement.manage.trackingRevision": "For revision {number}",
  "engagement.manage.trackingError": "We couldn’t load who has acknowledged it.",
  "engagement.manage.trackingFilter": "Show",
  "engagement.manage.acknowledgedOf": "{done} of {total} acknowledged",
  "engagement.manage.notYet": "Not yet",
  "engagement.manage.acknowledged": "Acknowledged",
  "engagement.manage.copyNames": "Copy names",
  "engagement.manage.namesCopied": "{count, plural, one {One name copied for a reminder.} other {# names copied for a reminder.}}",
  "engagement.manage.everyoneDone": "Everyone has acknowledged this revision.",
  "engagement.manage.nobodyYet": "Nobody has acknowledged this revision yet.",
  "engagement.surveysAdmin.intro": "Build pulse and eNPS surveys, open them to the team and read the results from 3 responses.",
  "engagement.surveysAdmin.caption": "Surveys",
  "engagement.surveysAdmin.new": "New survey",
  "engagement.surveysAdmin.emptyTitle": "No surveys yet",
  "engagement.surveysAdmin.emptyBody": "Start with a short pulse or an eNPS survey.",
  "engagement.surveysAdmin.responses": "Responses",
  "engagement.surveysAdmin.results": "Results",
  "engagement.surveysAdmin.resultsNamed": "Results of “{title}”",
  "engagement.surveysAdmin.edit": "Edit",
  "engagement.surveysAdmin.statusDraft": "Draft",
  "engagement.surveysAdmin.statusOpen": "Open",
  "engagement.surveysAdmin.statusClosed": "Closed",
  "engagement.surveysAdmin.open": "Open survey",
  "engagement.surveysAdmin.openTitle": "Open “{title}”?",
  "engagement.surveysAdmin.openBody": "Everyone can answer from now on. Its questions and whether it is anonymous can’t change after it opens.",
  "engagement.surveysAdmin.openedToast": "Survey open.",
  "engagement.surveysAdmin.close": "Close survey",
  "engagement.surveysAdmin.closeTitle": "Close “{title}”?",
  "engagement.surveysAdmin.closeBody": "It stops taking answers. You can reopen it for latecomers.",
  "engagement.surveysAdmin.closedToast": "Survey closed.",
  "engagement.surveysAdmin.reopen": "Reopen",
  "engagement.surveysAdmin.reopenTitle": "Reopen “{title}”?",
  "engagement.surveysAdmin.reopenBody": "People who haven’t answered yet can answer again. Answers already given stay as they are.",
  "engagement.surveysAdmin.reopenedToast": "Survey reopened.",
  "engagement.builder.newTitle": "New survey",
  "engagement.builder.editTitle": "Edit survey",
  "engagement.builder.back": "All surveys",
  "engagement.builder.settings": "Survey",
  "engagement.builder.introAr": "Introduction in Arabic",
  "engagement.builder.introEn": "Introduction in English",
  "engagement.builder.kind": "Kind",
  "engagement.builder.kindPulse": "Pulse",
  "engagement.builder.kindEnps": "eNPS",
  "engagement.builder.kindCustom": "Custom",
  "engagement.builder.anonymous": "Anonymous",
  "engagement.builder.anonymousOnHint": "Nobody, HR included, can see who gave which answer. Fixed once the survey opens.",
  "engagement.builder.anonymousOffHint": "Answers keep people’s names, and respondents are told so before they answer. Fixed once the survey opens.",
  "engagement.builder.closesOn": "Closes on",
  "engagement.builder.closesOnHint": "Optional. Answers are taken until the end of that day.",
  "engagement.builder.questions": "Questions",
  "engagement.builder.add": "Add a question:",
  "engagement.builder.questionScale": "Scale 1–5",
  "engagement.builder.questionNps": "eNPS 0–10",
  "engagement.builder.questionChoice": "Choice",
  "engagement.builder.questionText": "Written answer",
  "engagement.builder.questionKind": "Kind of question {number}",
  "engagement.builder.promptAr": "Question in Arabic",
  "engagement.builder.promptEn": "Question in English",
  "engagement.builder.required": "Required",
  "engagement.builder.moveUp": "Move question {number} up",
  "engagement.builder.moveDown": "Move question {number} down",
  "engagement.builder.removeQuestion": "Remove question {number}",
  "engagement.builder.options": "Choices",
  "engagement.builder.optionAr": "Choice {number} in Arabic",
  "engagement.builder.optionEn": "Choice {number} in English",
  "engagement.builder.optionArPlaceholder": "بالعربي",
  "engagement.builder.optionEnPlaceholder": "In English",
  "engagement.builder.removeOption": "Remove choice {number}",
  "engagement.builder.addOption": "Add a choice",
  "engagement.builder.errors.promptAr": "Write the question in Arabic.",
  "engagement.builder.errors.promptEn": "Write the question in English.",
  "engagement.builder.errors.options": "Give 2 to 12 choices, each in Arabic and English.",
  "engagement.builder.errors.noQuestions": "Ask at least one question.",
  "engagement.builder.enpsStandardAr": "على مقياس من 0 لـ 10، قد إيه ممكن ترشّح 404 Creative كمكان للشغل لصاحب أو قريب؟",
  "engagement.builder.enpsStandardEn": "On a scale of 0 to 10, how likely are you to recommend 404 Creative as a place to work to a friend?",
  "engagement.builder.lockNote": "Questions and anonymity are fixed once the survey opens.",
  "engagement.builder.saved": "Survey saved as a draft.",
  "engagement.builder.fixedTitle": "This survey can no longer change",
  "engagement.builder.fixedBody": "Once a survey opens, its questions and anonymity are fixed so every answer means the same thing.",
  "engagement.results.loadError": "We couldn’t load the results.",
  "engagement.results.draft": "Results appear once the survey is open and people answer.",
  "engagement.results.hiddenTitle": "{count} of {total} responses needed to show results",
  "engagement.results.hiddenBody": "{count, plural, one {One more response and the results appear. Until then nothing is shown, so no answer can be traced to anyone.} other {# more responses and the results appear. Until then nothing is shown, so no answer can be traced to anyone.}}",
  "engagement.results.responses": "Responses",
  "engagement.results.invited": "{count, plural, one {of # person invited} other {of # people invited}}",
  "engagement.results.rate": "Response rate",
  "engagement.results.enpsTitle": "Employee net promoter score (eNPS)",
  "engagement.results.enpsHint": "Share of promoters minus share of detractors.",
  "engagement.results.enpsScale": "From −100 to +100",
  "engagement.results.promoters": "Promoters",
  "engagement.results.passives": "Passives",
  "engagement.results.detractors": "Detractors",
  "engagement.results.promotersRange": "Answered 9–10",
  "engagement.results.passivesRange": "Answered 7–8",
  "engagement.results.detractorsRange": "Answered 0–6",
  "engagement.results.questionTitle": "{number}. {title}",
  "engagement.results.answered": "{count, plural, one {# answer} other {# answers}}",
  "engagement.results.meanOf": "{count, plural, one {# answer} other {# answers}} · average {number} of {total}",
  "engagement.results.textCount": "{count, plural, one {# written answer, in alphabetical order} other {# written answers, in alphabetical order}}",
  "engagement.results.noTexts": "Nobody wrote an answer to this question.",
  "engagement.results.columnAnswer": "Answer",
  "engagement.results.columnCount": "Responses",
  "engagement.results.columnShare": "Share",
  "engagement.results.byDepartment": "Responses by department",
  "engagement.results.byDepartmentHint": "Departments with fewer than 3 responses are merged, so nobody is singled out.",
  "engagement.results.otherDepartments": "Other departments",
  "engagement.results.noDepartments": "No department has enough responses to show on its own.",
  "engagement.home.sectionLabel": "People",
  "engagement.home.waitingTitle": "Waiting for you",
  "engagement.home.allDone": "You’re all caught up.",
  "engagement.home.loadError": "We couldn’t load this.",
  "engagement.home.decisions": "{count, plural, one {Request to decide} other {Requests to decide}}",
  "engagement.home.checklist": "{count, plural, one {Checklist task} other {Checklist tasks}}",
  "engagement.home.reviews": "{count, plural, one {Review to write} other {Reviews to write}}",
  "engagement.home.interviews": "{count, plural, one {Interview today} other {Interviews today}}",
  "engagement.home.policies": "{count, plural, one {Policy to acknowledge} other {Policies to acknowledge}}",
  "engagement.home.surveys": "{count, plural, one {Survey to answer} other {Surveys to answer}}",
  "engagement.home.announcements": "{count, plural, one {Unread announcement} other {Unread announcements}}",
  "engagement.home.outTitle": "Out today",
  "engagement.home.outCount": "{count, plural, one {# person} other {# people}}",
  "engagement.home.nobodyOut": "Everyone’s in today.",
  "engagement.home.backAfter": "Until {date}",
  "engagement.home.todayOnly": "Today only",
  "engagement.home.celebrationsTitle": "Celebrations this week",
  "engagement.home.noCelebrations": "No birthdays or work anniversaries this week.",
  "engagement.home.seeAll": "See all"
}
